export class RouteNames {
    static aboutMe: string = "/about-me";
    static links: string = "/links";
    static shCoding: string = "/SH-Coding";
    static shCodingPokeManager: string = RouteNames.shCoding + "/Poke-Manager";
    static shCodingCountdowns: string = RouteNames.shCoding + "/Countdowns";
    static shCodingInkLog: string = RouteNames.shCoding + "/InkLog";
    static legalNotice: string = "/legal-notice";
}
